import { useStore } from 'react-redux';
import { AnyAction, Store } from 'redux';
import { useEffect, useRef } from 'react';

export function useReduxActionListener<Payload>(actionType: string, onPayload: (payload: Payload) => void): void {
    const store = useStore() as Store<any> & { lastAction?: AnyAction };
    const handlerRef = useRef(onPayload);
    const prevActionRef = useRef<AnyAction | null>(null);

    handlerRef.current = onPayload;

    useEffect(() => {
        const lastNow = store.lastAction;
        if (lastNow && lastNow.type === actionType) {
            handlerRef.current(lastNow.payload as Payload);
            prevActionRef.current = lastNow;
        }

        const unsubscribe = store.subscribe(() => {
            const last = store.lastAction;
            if (last && last.type === actionType && last !== prevActionRef.current) {
                handlerRef.current(last.payload as Payload);
            }
            prevActionRef.current = last || null;
        });

        return unsubscribe;
    }, [store, actionType]);
}
